var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerMosaico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 466,
    viewBox: "0 0 430 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1105_22016)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    width: 397,
    height: 119,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    width: 397,
    height: 119,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25 25.75H188.75C184.608 25.75 181.25 29.1079 181.25 33.25V85.75C181.25 89.8921 184.608 93.25 188.75 93.25H241.25C245.392 93.25 248.75 89.8921 248.75 85.75V33.25C248.75 29.1079 245.392 25.75 241.25 25.75Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.875 52C204.982 52 207.5 49.4816 207.5 46.375C207.5 43.2684 204.982 40.75 201.875 40.75C198.768 40.75 196.25 43.2684 196.25 46.375C196.25 49.4816 198.768 52 201.875 52Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.75 70.75L230 52L188.75 93.25",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 128,
    width: 194,
    height: 210,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 128,
    width: 194,
    height: 210,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.25 199.75H87.75C83.6079 199.75 80.25 203.108 80.25 207.25V259.75C80.25 263.892 83.6079 267.25 87.75 267.25H140.25C144.392 267.25 147.75 263.892 147.75 259.75V207.25C147.75 203.108 144.392 199.75 140.25 199.75Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.875 226C103.982 226 106.5 223.482 106.5 220.375C106.5 217.268 103.982 214.75 100.875 214.75C97.7684 214.75 95.25 217.268 95.25 220.375C95.25 223.482 97.7684 226 100.875 226Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.75 244.75L129 226L87.75 267.25",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 128,
    width: 194,
    height: 210,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 128,
    width: 194,
    height: 210,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.25 199.75H290.75C286.608 199.75 283.25 203.108 283.25 207.25V259.75C283.25 263.892 286.608 267.25 290.75 267.25H343.25C347.392 267.25 350.75 263.892 350.75 259.75V207.25C350.75 203.108 347.392 199.75 343.25 199.75Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.875 226C306.982 226 309.5 223.482 309.5 220.375C309.5 217.268 306.982 214.75 303.875 214.75C300.768 214.75 298.25 217.268 298.25 220.375C298.25 223.482 300.768 226 303.875 226Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.75 244.75L332 226L290.75 267.25",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 347,
    width: 397,
    height: 119,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 347,
    width: 397,
    height: 119,
    rx: 9.5,
    stroke: "#767D8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25 373.25H188.75C184.608 373.25 181.25 376.608 181.25 380.75V433.25C181.25 437.392 184.608 440.75 188.75 440.75H241.25C245.392 440.75 248.75 437.392 248.75 433.25V380.75C248.75 376.608 245.392 373.25 241.25 373.25Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.875 399.5C204.982 399.5 207.5 396.982 207.5 393.875C207.5 390.768 204.982 388.25 201.875 388.25C198.768 388.25 196.25 390.768 196.25 393.875C196.25 396.982 198.768 399.5 201.875 399.5Z",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.75 418.25L230 399.5L188.75 440.75",
    stroke: "#767D8C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1105_22016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 466,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerMosaico);
export default __webpack_public_path__ + "static/media/bannerMosaico.31b63ffd61b336acf9dd57ff19233845.svg";
export { ForwardRef as ReactComponent };